var map = {
	"./hotel1.png": 2372,
	"./hotel2.png": 5223,
	"./hotel3.png": 1622,
	"./hotel4.png": 3471,
	"./hotel5.png": 2976,
	"./hotel6.png": 713,
	"./hotel7.png": 6948,
	"./hotel8.png": 4037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7966;